export const FEATURE_NAME = '@vshosting/cdn/features/purge-log-dialog';
